import { Directive, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Directive({
  host: { "(ionChange)": "onValueChange($event)" },
  selector: "[number-input]",
})
export class NumberInputDirective {

  @Input() public control: FormControl;

  public onValueChange(ev) {
    if (!ev) { return; }
    if (!ev.value) { return; }
    const value = parseInt(ev.value, 10);
    this.control.setValue(value);
  }

}



// WEBPACK FOOTER //
// ./src/directives/number-input/number-input.directive.ts